import { render, staticRenderFns } from "./ScenicspotDetail.vue?vue&type=template&id=c8f43c34&scoped=true"
import script from "./ScenicspotDetail.vue?vue&type=script&lang=js"
export * from "./ScenicspotDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f43c34",
  null
  
)

export default component.exports